import * as styles from "./StepConnector.module.scss";

export interface StepConnectorProps {
	/** 1 = arrow between steps 1→2, 2 = arrow between steps 2→3 */
	variant: 1 | 2;
}

/** Curved arrow between step cards (desktop only). */
export function StepConnector({ variant }: StepConnectorProps) {
	return (
		<span
			className={`${styles["step-connector"]} ${styles[`step-connector--${variant}`]}`}
			aria-hidden="true"
		/>
	);
}
